export enum AbTestWinnerOptions {
  implementTestWinnerInCheckout = 'implementTestWinnerInCheckout',
  implementOnlySpecificSegments = 'implementOnlySpecificSegments',
  dontImplementAnyChange = 'dontImplementAnyChange',
}
